<template>
    <client-page>
        <sub-visual sh="시설 및 참여" tabActive="코칭스탭" bg="/images/sub/visual/sv2.jpg"> </sub-visual>

        <section class="section">
            <v-container>
                <dept3-tab page="코칭스탭" tabActive="2" />
                <sub-staff-tab sport="soccer" />

                <staff-profile-layout v-bind="profile" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import Dept3Tab from "@/components/client/ko/sub/dept3-tab.vue";
import SlidePrimary from "@/components/client/ko/sub/sub-slide-primary.vue";
import StaffTop from "@/components/client/ko/sub/sub-staff-top.vue";

import SubStaffTab from "@/components/client/ko/sub/sub-staff-tab.vue";
import StaffProfileLayout from "@/components/client/ko/center/staff-profile-layout.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        Dept3Tab,
        SlidePrimary,
        StaffTop,

        SubStaffTab,
        StaffProfileLayout,
    },

    data() {
        return {
            profile: [
                {
                    position: "코치",
                    name: "정다훈",
                    items: [
                        {
                            subject: "학력",
                            content: [
                                "숭의고등학교 - 전남과학대학교",
                                //
                            ],
                        },
                        {
                            subject: "자격증",
                            content: [
                                "생활스포츠지도사 2급(축구)",
                                //
                            ],
                        },
                        {
                            subject: "경력",
                            content: [
                                "재단법인 유더스타스포츠 유아 축구 담당",
                                //
                            ],
                        },
                    ],
                    image: "/images/sub/center/staff/JeongDahoon.jpg",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped></style>
